import * as constantes from "../constants/constantes.js";
const ENDPOINT = constantes.URLAPI;
const ENDPOINTTEST = constantes.URL_TESTCURSO;

export const ObtenerEvaluacionesPersonaCurso = async({jwt,id})=> {
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerEvaluacionesPersonaCurso/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerEvaluacionesPersonaCurso/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ListarCursos`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        console.log("response", res)
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const RegistrarEvaluaciones= ({jsonEvaluacion,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/RegistrarEvaluaciones`,{
    return fetch(`${ENDPOINT}/ZADUsuario/RegistrarEvaluaciones`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: jsonEvaluacion
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const ActualizarEvaluaciones= ({jsonEvaluacion,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/ActualizarEvaluaciones`,{
    return fetch(`${ENDPOINT}/ZADUsuario/ActualizarEvaluaciones`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: jsonEvaluacion
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}
export const BuscarEvaluacionPorId = async({jwt,id})=> {
    return await fetch(`${ENDPOINT}/ZADCurso/BuscarEvaluacionPorId/${id}`,{
    //return await fetch(`${ENDPOINTTEST}/ListarCursos`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}
